import React from 'react'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

import ConnectPayroll from './components/connect.payroll.component'

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar navbar-expand-lg navbar-light fixed-top image-container title-gradient">
              <img src='logo.png' alt='notchup' width='140px'></img>
        </nav>
        <div className="main-container">
          <div>
            <h1>
              <span className="emphasisTitle">Almost There!</span>&nbsp;&nbsp;Verify Your Income &amp; Identity
            </h1>
          </div>
          <div className="main-text">
            <p>You're just one step away from completing your NotchUp setup! To ensure we have the most accurate information, please connect your payroll account through our secure platform. This will help us verify your income and identity quickly and safely. Rest assured, your data is protected with top-notch encryption. Click the button below to connect your payroll account and move closer to finalizing your application.</p>
          </div>
          <div className="auth-wrapper">
            <div className="auth-inner">
              <Routes>
                <Route path="/" element={<ConnectPayroll />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </Router>
  )
}

export default App
